<mode-channel-component
  [channelSummary]="channelSummary"
  [encoding]="encoding"
  [model]="model"
  [view]="view"
  [chartService]="chartService"
  [chartType]="chartType"
  [fieldFormatMap]="fieldFormatMap"
  [format]="format"
  [series]="series"
  [queryToken]="queryToken"
  [vizToken]="vizToken"
  [allowContinuous]="true"
  [allowScalars]="allowScalars"
  [allowDiscrete]="false"
  [allowBinned]="false"
  [requiresContinuous]="true"
  [binSizeToFieldMap]="binSizeToFieldMap"
>
</mode-channel-component>
